<div class="landing-page-sec">
  <nav class="navbar navbar-inverse navbar-fixed-top">
    <div class="container">
      <div class="col-xs-12 pad0">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false"
            aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#">
            <img src="assets/img/SG-landing-page-logo.png" />
          </a>
        </div>
        <div id="navbar" class="navbar-collapse collapse" aria-expanded="false" style="height: 1px;">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <a (click)="navigateToSignup()" target="_blank" class="btn btn-creat-acc">Create Free Account / Log In</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <div class="main-sec">
    <section class="overview-sec view-bg">
      <div class="container-fluid">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">2019 NFL Fantasy Football Is Back</h2>
          </div>

          <div class="tbl-sec">
            <div class="col-md-5 col-sm-6 col-sm-12 lft-sec tbl-cell">
              <p class="text-left">Before long, the NFL will be back and the heart of the Fantasy Sports season will be upon us. In order to compete
                in Fantasy Football at the highest level there are
                <b>Two Things</b> that are a
                <b>MUST HAVE
                </b>.
                <b>
                  <u>You MUST HAVE reliable information</u>
                </b> and
                <b>
                  <u>you MUST HAVE opportunity</u>
                </b>. Reliable information is crucial but hard to come by. There are so many resources on the market today and
                choosing the right one can be difficult as well as time consuming. Finding the right opportunity to maximize
                your knowledge of Fantasy Football is yet another challenge. </p>
              <p class="text-left">Every week you are accumulating hours of research to set the best possible Fantasy Football line-up but once
                your roster has been selected, are you maximizing your opportunity?
                <b>
                  <u>For these reasons BigGuy Fantasy Sports and StatementGames Inc. have combined forces in an effort to give
                    Fantasy Football Fans reliable information &amp; opportunity.
                  </u>
                </b>
              </p>
            </div>
            <div class="col-md-7 col-sm-6 col-sm-12  ximg-sec text-center tbl-cell signin-div nfl-landing sign-bg-img" style="vertical-align: top;">
              <img src="assets/img/logo-fantasy.png" width="200" style="margin-bottom:10px;" />
              <div class="clearfix"></div>
              <iframe width="520" height="300" class="vd-frame" src="https://www.youtube.com/embed/laF7uyeVDhI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
              <div class="clearfix"></div>
              <p style="line-height: 24px;margin-top:10px; font-weight: bold;">Signing up for StatementGames is simple.
                <br>You can even do so with your Google Account. </p>
            </div>
          </div>
          <br>
          <div class="text-center">
            <a (click)="navigateToSignup()" target="_blank" class="btn btn-creat-acc minwd245">Create Free Account / Log In</a>
          </div>
        </div>
      </div>
    </section>
    <section class="fantasy-sports xbg-red txt-blk">
      <div class="container-fluid">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">About www.bigguyfantasysports.com</h2>
            <div class="clearfix"></div>

          </div>
          <div class="col-md-6 col-sm-12 cnt-sec col-md-push-6">
            <p class=" text-left">Big Guy Fantasy Sports is a premium service that
              <b>helps its members identify fantasy football consistency patterns and trends.</b> Through the services of Big
              Guy Fantasy Sports you will be able to draft even more competitive Fantasy Football teams / daily &amp; weekly
              line-ups. The site is owned by Fantasy Football expert, Bob Lung, who has been playing Fantasy Football since
              1985.
            </p>

            <p class=" text-left">Bob has been provided his thoughts on how consistency can help your fantasy team for over 16 years. He started
              writing for Rotojunkie in 2002 and has progressed through many top national sites like CreativeSports, Fox
              Sports, Fanball &amp; RotoExperts. He was a speaker at the 2012 Fantasy Fest in Atlantic City and has been
              featured in many podcasts and radio channels like Sirius XM Fantasy Sports Radio. Since 2015, he has been invited
              to participate in the NFFC’s Pros Vs Joes and the Fantasy League of Experts (FLEX) hosted by RotoExperts. In
              2018, Bob created the King’s Classic Fantasy Football Expert draft held at the Pro Football Hall of Fame in
              Canton, Ohio and is now an annual event. Over the past two years, his annual Fantasy Football Consistency Guide
              was nominated as a finalist for Best Fantasy Football Publication of the Year and was named the winner for
              his 2018 version. His passion is in bringing the power of consistency to your Fantasy teams in a way that helps
              you WIN Championships.</p>
            <div class="clearfix"></div>
            <br>

          </div>

          <div class="col-md-6 col-sm-12 text-center ximg-sec col-md-pull-6 text-center">
            <div class="text-center">
              <img src="assets/img/dashboard-h.PNG" />
            </div>
            <br>
            <div class="text-left col-md-7 col-sm-11 col-sm-sm-12 pad0 fltnon">
              <h4>Step1 -
                <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
              </h4>

              <h4>Step2 -
                <a (click)="navigateToSignup()" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Subscription</a>
              </h4>

            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="our-offers pad-sec" style="background: #fceced">
      <div class="container">
        <div class="col-xs-12">

          <div class="title-sec text-center">
            <h2 class="">About StatementGames Inc. </h2>
          </div>
          <p class="">
            <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> is a Patent Pending Fantasy Football / Fantasy Sports gaming platform that brings
            a unique twist to the sports community. An overview of how we are different can be found in the video below.
            By combing simplicity with innovation STATEMENTGAMES has been highlighted on ABC, CBS, NBC &amp; FOX. New members
            have the ability to create a FREE account on
            <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> at any time but the platform is a Virtual Coin based platform. The objective of all
            community members is in competing for and acquiring as many virtual coins as possible. Then, when enough StatementGames
            coins have been acquired – exchange your coins for $ gift cards of your choice. Hundreds of brands to choose
            from including Amazon, Domino’s, Google Play, NFL Shop, Target, Xbox, AMC Theatres, Fanatics, App Store &amp;
            iTunes, Nike, Walmart, etc.</p>
        </div>
      </div>
    </section>


    <section class="our-offers pad-sec">
      <div class="container">
        <div class="col-xs-12 pad0">

          <div class="title-sec text-center">
            <h2 class="">The best Fantasy Football offer of 2019</h2>
          </div>


          <h4 style="margin-top:15px; text-align: center;">
            <strong>
              <span class="txt-bg text-center">Killing 2 Birds With 1 Stone - What You Are Getting With A 1 YR Big Guy Fantasy Sports Subscription. </span>
              <!--– The VIP BigGuy Fantasy Sports &amp; StatementGames
Subscription – What You Get For ONLY $59.49.-->
            </strong>
          </h4>
          <ul class="point-list lst-bg-non">
            <li>1) Digital Copy of the 2019 Big Guy Fantasy Consistency Guide</li>
            <li>2) From the time of your order up until NFL week 1 the Big Guy Fantasy Consistency Guide will be updated. You
              will receive an updated copy of the guide after every edit.</li>
            <li>3) Unlimited access to all articles posted on www.bigguyfantasysports.com from the time of your order through
              the end of the 2019 NFL Season.</li>
            <li>4) Access to Bob Lung to send your Fantasy Football questions, which he will answer personally.
            </li>
            <li>5) Free
              <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> account. With your account you will receive 60 FREE StatementGames Coins upon account
              sign up.</li>
            <li>6) 100 StatementGames Coins will be added to your account monthly for 12 consecutive months.
            </li>
            <li>7) Your 100 monthly coins COUNT towards “COINS EARNED” on the StatementGames LEADERBOARD.
            </li>
          </ul>
          <h4 class="text-center value-txt">
            <strong>*** TOTAL VALUE Of $121.26 YOURS FOR ONLY $59.49 – OVER 50% Off Current Retail Rate***</strong>
          </h4>
          <br>
          <div class="text-left col-md-4 col-sm-7 col-sm-12 pad0 fltnon">
            <h4>Step1 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
            </h4>

            <h4>Step2 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Subscription</a>
            </h4>

          </div>
          <!--  <div class="text-center">
         <a href="https://www.statementgames.com/#/landing/signin" target="_blank" class="btn btn-creat-acc-wht">Create Free Account / Log In</a>&nbsp;&nbsp;<a href="#" class="btn btn-creat-acc-wht bg-wht">Buy Subscription</a>
	
			</div>  -->
        </div>
      </div>
    </section>








    <section class="should-buy pad-sec ">
      <div class="container">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">10 Reasons Why You Should Buy Now</h2>
          </div>
          <div class="col-sm-6">
            <ul class="point-list">
              <li>
                <span>1</span>The Fantasy Football Consistency Guide is an Amazon #1 seller! 2018 winner of the FSWA “Best Fantasy
                Football Publication”.</li>
              <li>
                <span>2</span>Time is $$$ - Cut your research time in HALF with a Big Guy Fantasy Sports / StatementGames Inc.
                Subscription. All the data that you can ever need in drafting a Fantasy Football Team will be at your fingertips.</li>
              <li>
                <span>3</span>Reliability – If you belong to a traditional 10 or 12-person Fantasy Football league you will outperform
                OVER 70% of your league by fully utilizing your Big Guy Fantasy Sports / StatementGames Inc. Subscription.</li>
              <li>
                <span>4</span>Got Fantasy Football questions – how often do you have an opportunity to contact an industry expert
                DIRECTLY and get a response?</li>
              <li>
                <span>5</span>The information that you will gleam from
                <a href="https://www.bigguyfantasysports.com/" target="_blank">bigguyfantasysports.com</a> is going to assist you in other areas of gaming and in making OVER / UNDER Prop
                Picks on StatementGames. More opportunities to compete &amp; WIN.</li>

            </ul>
          </div>
          <div class="col-sm-6">
            <ul class="point-list">
              <li>
                <span>6</span>On
                <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com,</a> 60 Coins retail for $4.49 – You are getting 1,200 coins for $59.49!
              </li>
              <li>
                <span>7</span>Having 100 StatementGames Coins added to your account monthly gives subscribers a distinct competitive
                advantage on the StatementGames LEADERBOARD Vs Non-Subscribers.</li>
              <li>
                <span>8</span>90% of Big Guy Fantasy Sports / StatementGames Inc. subscribers WIN more coins over the course of
                a given month on
                <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> than NON-Subscribers. Coins that can be exchanged for $ E-Gift Cards.</li>
              <li>
                <span>9</span>If you did NOTHING with your www.statementgames.com account you would be able to exchange your 1,200
                coins for a $12 E-Gift Card via StatementGames REWARDS. Hundreds of brands to choose from including Amazon,
                Domino’s, Google Play, NFL Shop, Target, Xbox, AMC Theatres, Fanatics, App Store &amp; iTunes, Nike, Walmart,
                etc.
              </li>
              <li>
                <span>10</span>At the end of your Big Guy Fantasy Sports / StatementGames Inc. subscription, IF YOU ARE NOT SATISIFED
                with our service we will REFUND your $ no questions asked.</li>
            </ul>
          </div>

          <div class="text-left col-md-4 col-sm-7 col-sm-12 pad0 fltnon">
            <h4>Step1 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
            </h4>

            <h4>Step2 -&nbsp;&nbsp;
              <a href="#" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Now</a>
            </h4>

          </div>
          <!--    <div class="text-center">
         <a href="https://www.statementgames.com/#/landing/signin" target="_blank" class="btn btn-creat-acc-wht">Create Free Account / Log In</a>&nbsp;&nbsp;<a href="#" class="btn btn-creat-acc-wht bg-wht">Buy Now</a>
		
			</div> -->

        </div>

      </div>
    </section>


    <section class=" testimonial-sec pad-sec bgnon">
      <div class="container">
        <div class="title-sec text-center">
          <h2 class="">Testimonial</h2>
        </div>

        <div class="logo-icons-wins">
          <ul class="list-inline">
            <li>
              <img alt="" src="assets/img/wings.png">
            </li>
            <li>
              <div class="social-section">
                <i aria-hidden="true" class="fa fa-twitter"></i>
                <i aria-hidden="true" class="fa fa-facebook"></i>
              </div>
            </li>
            <li class="test-email">
              <h4 class="splash-page__tweets-handle">@Statementgames</h4>
            </li>
          </ul>
        </div>


        <!-- <div class="owl-carousel testimonials-carousel"> -->
        <div class="row">
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/Realkuj.jpg" class="pro-logo" width="73" />
                  <h3>
                    <a href="https://twitter.com/therealkuj" target="_blank">@therealkuj</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>I will compete in multiple big $ Fantasy Football leagues per year and would not do so without the services
                    of BigGuy Fantasy Sports.
                  </p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal1" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/Eroll.jpg" class="pro-logo" />
                  <h3>
                    <a href=" https://twitter.com/ErrolMarks34" target="_blank">@ErrolMarks34</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>www.statementgames.com – what a great concept! Through playing StatementGames I have a brand new take on
                    Monday Night Football...</p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal3" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/TPE.jpg" class="pro-logo" />
                  <h3>
                    <a href="https://twitter.com/PinstripEmpire" target="_blank">@PinstripEmpire</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>What a great service! With the BigGuy Fantasy Sports / StatementGames Inc. subscription I am able to draft
                    teams and set line-ups with confidence!...</p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal2" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="address-sec">
            <img src="assets/img/SG-landing-page-logo.png" width="280px" />
            <address>
              <p>
                <i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;New York, USA.</p>
              <p>
                <a href="#">
                  <i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;marketing@statementgames.com</a>
              </p>
              <!--  <p><a href="#"><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;1-833-232-1702</a></p>-->
            </address>
          </div>
        </div>
        <div class="col-sm-4 ftr-link">
          <h4>Our Links</h4>
          <ul>
            <li>
              <a href="#">About</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">FAQ</a>
            </li>

            <li>
              <a href="#">Rules</a>
            </li>
            <li>
              <a href="#">Support</a>
            </li>

            <li>
              <a href="#">Terms & Conditions</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div class="col-sm-3 social-sec">
          <h4>Social Connect:</h4>
          <ul class="social-links list-inline">
            <li>
              <a href="https://www.facebook.com/StatementGames/" target="_blank">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/statementgames" target="_blank">
                <i class="fa fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
            <!--<li><a href="#" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>-->
            <!--       <li><a href="https://plus.google.com/104605028988485215379" target="_blank"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>-->
            <li>
              <a href="https://www.instagram.com/statementgames/" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCZtETt-wK0OnF_AHbQ5RRhQ?view_as=subscriber" target="_blank">
                <i class="fa fa-youtube" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-btm">
      <div class="container text-center">
        <p>2019 StatementGames Inc.</p>
      </div>
    </div>
  </footer>
</div>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js"></script>
<script src="js/bootstrap.min.js"></script>
<script src="js/owl.carousel.min.js"></script>

<div class="model-popup-video">
  <div id="myModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">×</button>
        </div>
        <div class="modal-body">
          <iframe width="100%" height="295" src="https://www.youtube.com/embed/laF7uyeVDhI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="myModal1" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/Realkuj.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@therealkuj

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            I will compete in multiple big $ Fantasy Football leagues per year and would not do so without the services of Big Guy Fantasy
            Sports. From their research I can attribute Over 10K in league winnings. A tremendous help from drafting teams
            to setting line-ups. Whenever I was faced with a challenging line-up question – Bob was able to advise me through
            every step.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="myModal2" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/TPE.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@PinstripEmpire

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            What a great service! With the Big Guy Fantasy Sports / StatementGames Inc. subscription I am able to draft teams and set
            line-ups with confidence! In a short period of time, I have also been able to make OVER / UNDER prop picks on
            www.statementgames.com and turn my 100 monthly coins into a $25 Dominios gift card. This 2019 NFL season I plan
            on having my pizza and wings compt by StatementGames.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/Eroll.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@ErrolMarks34

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            www.statementgames.com – what a great concept! Through playing StatementGames I have a brand new take on Monday Night Football.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>